import { Card, Divider, Button } from "antd";
import React, { useState } from "react";




const PerformanceCard = (props) => {
  const { name, role, department, dueStatus, lastDate, nextDate, children } = props;



  return (
    
      <Card className="rounded-2xl border border-gray-200 hover:shadow-md relative dark-mode-card" >
        <div className="flex justify-between items-start">
          <span className={`absolute items-center right-5 text-xs border status-indicator ${dueStatus.toLowerCase().replace(/\s+/g, "-")}`}>
            {dueStatus}
          </span>
          <div className="flex items-center space-x-3">
            <div className="w-10 h-10 flex items-center justify-center rounded-full bg-gray-100 text-gray-700 font-semibold">
              {name ? name.split(" ").map((n) => n[0]).join("") : ""}
            </div>
            <div>
              <h3 className="font-semibold text-gray-800 dark:text-white">{name}</h3>
              <div className="flex items-center text-gray-600 text-sm dark:text-slate-100">{role}</div>
              <div className="flex items-center text-gray-600 text-sm dark:text-slate-100">{department}</div>
            </div>
          </div>
        </div>

        <Divider style={{ margin: "0.5rem 0", borderColor: "#e5e7eb" }} />

        <div className="text-sm text-gray-600 my-2">
          <div className="flex justify-between ">
            <p className="dark:text-slate-100">Last Review:</p>
            <p className="font-semibold text-gray-700 dark: dark:text-slate-200">{lastDate}</p>
          </div>
          <div className="flex justify-between">
            <p className="dark:text-slate-100">Next Review:</p>
            <p className="font-semibold text-gray-700 dark:text-slate-200">{nextDate}</p>
          </div>
        </div>
        
        {children}
      </Card>
      
              
  );
};

export default PerformanceCard;
